export function toLegendValue(d) {
	var month = (d.getMonth() + 1),
		day = d.getDate(),
		year = d.getFullYear(),
		hour = d.getHours().toString(),
		minute = d.getMinutes().toString(),
		second = d.getSeconds().toString();

	if (month.length < 2) { 
		month = "0" + month;
	}
	if (day.length < 2) {
		day = "0" + day;
	}
	if (hour.length < 2) {
		hour = "0" + hour;
	}
	if (minute.length < 2) {
		minute = "0" + minute; 
	}
	if (second.length < 2) {
		second = "0" + second;
	}

	return [year, month, day].join("-") + " " + [hour, minute, second].join(":");
};

export function formatDate(date) {
	var d = new Date(date),
	  month = "" + (d.getMonth() + 1),
	  day = "" + d.getDate(),
	  year = d.getFullYear();
  
	if (month.length < 2) month = "0" + month;
	if (day.length < 2) day = "0" + day;
  
	return [year, month, day].join("-");
}

export function list10mPastTimes(frames=6) {
    let timeList = [];
    let d = new Date(); // utc date
    d.setTime(d.getTime() + (d.getTimezoneOffset() * 60 * 1000));

    let currentUtcMin = d.getMinutes();
    d.setSeconds(0);
    if (currentUtcMin < 10) {
        d.setMinutes(0);
    } else if (currentUtcMin < 20) {
      d.setMinutes(10);
    } else if (currentUtcMin < 30) {
      d.setMinutes(20);
    } else if (currentUtcMin < 40) {
      d.setMinutes(30);
    } else if (currentUtcMin < 50) {
      d.setMinutes(40);
    } else {
      d.setMinutes(50);
    }

    addMinutes(d, -10*(frames+1)); // we can only see the past, not the future

    for (var i = 0; i < frames; i++) {
        timeList.push(d.getTime());

        addMinutes(d, 10);
	}
    return timeList;
}

function list3HForecastHours() {
	return ["00", "03", "06", "09", "12", "15", "18", "21"];
}

function getNextForecastHourOffset(currentUtcHour) {
	let forecastHours = list3HForecastHours();

	for (var i in forecastHours) {
		if (parseInt(currentUtcHour, 10) > parseInt(forecastHours[i], 10)) {
			continue;
		}

		return parseInt(forecastHours[i], 10) - parseInt(currentUtcHour, 10);
	}
	// if the loop finishes, return 00 of the next day
	return 24 - parseInt(currentUtcHour, 10);
}

/*
Using current UTC hour, retrieves next available forecast hour from list of
possible values (Env. Can. only supplies forecasts for every 3 hours step).
After finding the next available forecast date, assemble list of formatted
time values for the API call (`yyyy-MM-ddThh:00:00Z).
*/
export function listForecastTimes(frames=6, m=180) {
	if (m == -10) {
		return list10mPastTimes(frames);
	}
	
	let timeList = [];
	let d = new Date(); // utc date
	d.setTime(d.getTime() + (d.getTimezoneOffset() * 60 * 1000));
	d.setMinutes(0);
	d.setSeconds(0);

	let currentUtcHour = d.getHours();
	if (m >= 180) {
		// set first forecast time to the next available forecast time given by Env. Can.
		// only applies to 3H intervals
		addHours(d, getNextForecastHourOffset(currentUtcHour));
	}

	for (var i = 0; i < frames; i++) {
		timeList.push(d.getTime());

		addMinutes(d, m);
	}
	return timeList;
}

export function formatDatetimeForGCApi(t) {
	let d = new Date();
	d.setTime(t);
  
	var month = "" + (d.getMonth() + 1).toString(),
	  day = "" + d.getDate().toString(),
	  year = d.getFullYear().toString(),
	  h = d.getHours().toString(),
	  m = d.getMinutes().toString();
  
	if (month.length < 2) month = "0" + month;
	if (day.length < 2) day = "0" + day;
	if (h.length < 2) h = "0" + h;
	if (m.length < 2) m = "0" + m;
  
	return [year, month, day].join("-") + "T" + h + ":"+ m +":00Z";
}

export function toDateInputValue(d) {
	d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
	return d.toJSON().slice(0, 10);
};

function getEDTStart() {
	var firstDayOfMarch = new Date(new Date().getFullYear(), 2, 1);
	if (firstDayOfMarch.getDay() == 7) {
		return firstDayOfMarch;
	}
	var date = new Date(new Date().getFullYear(), 2, 7);
	date.setDate(7 + (7 - date.getDay()));
	return date;
}

function getEDTEnd() {
	var date = new Date(new Date().getFullYear(), 8, 7);
	date.setDate(7 - date.getDay());
	return date;
}

export function getTimezoneOffset(d = new Date()) {
	let montrealOffset = -5;
	if (d >= getEDTStart() && d <= getEDTEnd()) {
		montrealOffset = -4;
	}
	return montrealOffset;
}

export function timestampToFormattedLocalTime(t) {
	let d = new Date();
	d.setTime(t);

	d = addHours(d, getTimezoneOffset(d))

	let m = d.getMinutes().toString()
	if (m.length < 2) m = "0" + m;

	return d.toLocaleDateString("en-CA", { weekday: 'long' }) + " " + d.getHours().toString() + ":" + m + ":00";
}

export function addHours(d, h) {
	d.setTime(d.getTime() + h * 60 * 60 * 1000);
	return d;
};

export function addMinutes(d, m) {
	d.setTime(d.getTime() + m * 60 * 1000);
	return d;
};

export function removeHours(d, h) {
	d.setTime(d.getTime() - (h * 60 * 60 * 1000));
	return d;
};

export function timeDifference(compare, to = new Date().getTime()) {
	let msec = compare - (to + (new Date().getTimezoneOffset() * 60 * 1000));
	return Math.round(msec / 1000 / 60 / 60);
};